import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CqComponent } from './cq.component';
import { PanelModule } from 'primeng/panel';
import { ContenusModule } from '../moderation/contenus/contenus.module';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { FormsModule } from '@angular/forms';
import { NgxChronometerModule } from 'ngx-chronometer';
import { ToastModule } from 'primeng/toast';
import { StickyNavModule } from 'ng2-sticky-nav';
import { BrowserModule } from '@angular/platform-browser';
import {CheckboxModule} from 'primeng/checkbox';
import { MailEditorComponent } from './mail-editor/mail-editor.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import {EditorModule} from 'primeng/editor';
import {CountdownModule} from 'ngx-countdown';

@NgModule({
  declarations: [CqComponent, MailEditorComponent],
  imports: [
    CommonModule,
    ContenusModule,
    PanelModule,
    ButtonModule,
    SidebarModule,
    DropdownModule,
    ToolbarModule,
    FormsModule,
    NgxChronometerModule,
    ToastModule,
    BrowserModule,
    StickyNavModule,
    CheckboxModule,
    DialogModule,
    InputTextModule,
    EditorModule,
    CountdownModule
  ]
})
export class CqModule { }
